export const ACTIONS = {
  SET_APP_COUNT_LOADING: "trend/SET_APP_COUNT_LOADING",
  SET_CUSTOM_LIST_LOADING: "trend/SET_CUSTOM_LIST_LOADING",
  SET_SELECTIONS_LOADING: "trend/SET_SELECTIONS_LOADING",
  SET_APP_COUNT: "trend/SET_APP_COUNT",
  SET_CUSTOM_LIST: "trend/SET_CUSTOM_LIST",
  SET_APP_CLASS_LIST: "trend/SET_APP_CLASS_LIST",
  SET_SELECTIONS: "trend/SET_SELECTIONS",
  SET_TIMEFILTER: "trend/SET_TIMEFILTER",
  SET_SELECTED_CUSTOM_FILTER: "trend/SET_SELECTED_CUSTOM_FILTER",
  SET_ERROR: "trend/SET_ERROR"
};
